import { cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';
import { ChatMessage } from './ChatTypes';

export const messagesHavePendingToolCalls = (messages: ChatMessage[]) => {
    // Clone because we going to mutate
    messages = [...messages];

    if (!messages || messages.length === 0) {
        return false;
    }

    // If last is a tool call
    const [am, tm] = (messages[messages.length - 1]?.role === 'tool')
        ? [messages[messages.length - 2], messages[messages.length - 1]]
        : [messages[messages.length - 1], null];

    if (am?.role !== 'assistant') {
        return false;
    }

    const toolCalls = am.content.filter(x => x.type === 'tool-call').map(x => (x as any).toolCallId);

    // For each tool call, look for a corresponding tool result call, if any not found then we have pending
    for (const tc of toolCalls) {
        if (!tm?.content.find(x => x.type === 'tool-result' && x.toolCallId === tc)) {
            return true;
        }
    }

    return false;
};

export const messagesAddToolResult = (messages: ChatMessage[], toolCallId: string, result: any) => {

    // Clone so we return new object
    messages = cloneDeep(messages);

    // Find the latest assitant message
    const lam = messages.findLast(m => m.role === 'assistant');
    // Find the corresponding tool call
    const tcmp = lam?.content.findLast(c => c.type === 'tool-call' && c.toolCallId === toolCallId);

    // If not there, throw error
    if (!tcmp || tcmp.type !== 'tool-call') {
        throw new Error(`Cannot find tool call ${toolCallId} in assistant message ${lam?.id}`);
    }

    // If we don't have a pending tool message with the call results, add one
    if (messages[messages.length - 1].role !== 'tool') {
        messages.push({
            role: 'tool',
            content: [],
            id: uuid(),
            createdAt: new Date(),
        });
    }

    const toolMessage = messages[messages.length - 1];
    if (toolMessage.role !== 'tool') {
        throw new Error('Tool message is not a tool message?');
    }

    // Verify we don't alread have a tool result for this call
    if (toolMessage.content.find(c => c.type === 'tool-result' && c.toolCallId === toolCallId)) {
        throw new Error(`Tool result for ${toolCallId} already exists`);
    }

    // Add the tool result
    toolMessage.content.push({
        type: 'tool-result',
        toolCallId,
        toolName: tcmp.toolName,
        result,
        isError: false,
    });

    return messages;
};
